import { PROJECT_UPDATE, PROJECT_VIEW } from "../../type";

export const projectViewAction = (id, onSuccess, onError) => {
  return { type: PROJECT_VIEW, id, onSuccess, onError };
};
export const projectUpdateAction = (data, onSuccess, onError) => {
  console.log(data, "aaaa");
  return { type: PROJECT_UPDATE, data, onSuccess, onError };
};
